var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown-group",
    { attrs: { header: _vm.$t("general.actions") } },
    [
      _vm.isMultiple
        ? _c(
            "div",
            _vm._l(_vm.filteredActions, function(action, i) {
              return _c("b-dropdown-item", { key: i }, [
                action.ViewType === "Modal"
                  ? _c(
                      "span",
                      {
                        staticClass: "d-inline-block w-100",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.showMultipleModal(action)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { width: "10", height: "10", src: _vm.icon }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(_vm._s(action.Title))
                        ])
                      ]
                    )
                  : action.ViewType === "Print"
                  ? _c(
                      "span",
                      {
                        staticClass: "d-inline-block w-100",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.multiPrint(action)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { width: "10", height: "10", src: _vm.icon }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(_vm._s(action.Title))
                        ])
                      ]
                    )
                  : action.ViewType === "Action" &&
                    action.Action === "SendAgain"
                  ? _c(
                      "span",
                      {
                        staticClass: "d-inline-block w-100",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.actionMethod(action)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { width: "10", height: "10", src: _vm.icon }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(_vm._s(action.Title))
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            }),
            1
          )
        : _c(
            "div",
            _vm._l(_vm.filteredActions, function(action, i) {
              return _c(
                "b-dropdown-item",
                {
                  key: i,
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.actionClick(action, _vm.row)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "d-inline-block w-100" }, [
                    _c("img", {
                      attrs: { width: "10", height: "10", src: _vm.icon }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-1" }, [
                      _vm._v(_vm._s(action.Title))
                    ])
                  ])
                ]
              )
            }),
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f45864b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f45864b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Actions/Actions.vue
// module id = null
// module chunks = 